import { translateFn } from '../../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../../ui/gzDataTable/types';
import { html, TemplateResult } from 'lit';
import { getAntimalwareAntiExploitApplicationStatusFormGrid } from '../../../../../utils/uiSettings/antimalware/antimalware.values';

export enum ColumnKeys {
  APP_NAME = 'applicationName',
  PROCESS_NAME = 'processName',
  STATUS = 'status',
}

export function getTableColumns(hasStatus: boolean, hasActions: boolean, onApplicationNameClick): IDataTableColumn[] {
  const columns: IDataTableColumn[] = [
    {
      key: ColumnKeys.APP_NAME,
      header: translateFn('Application'),
      columnType: IColumnType.DISPLAY,
      renderer: (content: string, column: IDataTableColumn, rowIndex: number, editMode?: boolean) =>
        applicationNameCellCustomRenderer(content, column, rowIndex, onApplicationNameClick),
    },
    {
      key: ColumnKeys.PROCESS_NAME,
      header: translateFn('Process name'),
      columnType: IColumnType.DISPLAY,
      renderer: processNameCellCustomRenderer.bind(this),
    },
  ];

  if (hasStatus) {
    columns.push({
      key: ColumnKeys.STATUS,
      header: translateFn('Status'),
      columnType: IColumnType.SINGLE_SELECT,
      options: getAntimalwareAntiExploitApplicationStatusFormGrid(),
    });
  }

  if (hasActions) {
    columns.push({
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    });
  }

  return columns;
}

export function applicationNameCellCustomRenderer(
  content: string,
  column: IDataTableColumn,
  rowIndex: number,
  onApplicationNameClick
): TemplateResult {
  return html`
    <gz-tooltip
      isEllipsis
      tooltipText="${content}"
      class="cell-label"
      style="cursor: pointer; color: var(--blue-layout-400-primary);"
    >
      <span @click="${e => onApplicationNameClick(rowIndex)}">${content}</span>
    </gz-tooltip>
  `;
}

export function processNameCellCustomRenderer(
  content: string[],
  column: IDataTableColumn,
  rowIndex: number
): TemplateResult {
  return html`
    <gz-tooltip isEllipsis tooltipText="${content.join('; ')}" class="cell-label"> ${content.join('; ')} </gz-tooltip>
  `;
}
